import{a as t,b as n,d as s,m as a}from"./chunk-HBP5N4FR.js";a();function T(y){let u=y,{default:c}=u,l=s(u,["default"]),r=t({default:c},l);return Object.keys(r).reduce((f,e)=>n(t({},f),{[e==="default"?"true":e]:r[e]}),{}).true}export{T as a};
//# sourceMappingURL=chunk-LK5TR7MI.js.map
